module.exports = __webpack_public_path__ + "static/media/book-later-mockup.2257a293.png";